var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarClockRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.75C4.5 0.334375 4.16563 0 3.75 0C3.33438 0 3 0.334375 3 0.75V2H2C0.895313 2 0 2.89531 0 4V14C0 15.1047 0.895313 16 2 16H9.20312C8.7625 15.5594 8.39687 15.05 8.11875 14.5H2C1.72375 14.5 1.5 14.2762 1.5 14V6H12.5V7.78125C13.0344 7.68437 13.5875 7.65625 14 7.65625V4C14 2.89531 13.1047 2 12 2H11V0.75C11 0.334375 10.6656 0 10.25 0C9.83438 0 9.5 0.334375 9.5 0.75V2H4.5V0.75ZM12.5 4V4.5H1.5V4C1.5 3.72375 1.72375 3.5 2 3.5H12C12.2762 3.5 12.5 3.72375 12.5 4ZM18 11.5C18 10.3065 17.5259 9.16193 16.682 8.31802C15.8381 7.47411 14.6935 7 13.5 7C12.3065 7 11.1619 7.47411 10.318 8.31802C9.47411 9.16193 9 10.3065 9 11.5C9 12.6935 9.47411 13.8381 10.318 14.682C11.1619 15.5259 12.3065 16 13.5 16C14.6935 16 15.8381 15.5259 16.682 14.682C17.5259 13.8381 18 12.6935 18 11.5ZM13 9.5C13 9.225 13.225 9 13.5 9C13.775 9 14 9.225 14 9.5V11.2812L15.1875 12.075C15.4156 12.2281 15.4781 12.5375 15.325 12.7687C15.1719 13 14.8625 13.0625 14.6312 12.9094L13.2188 11.9719C13.0844 11.8812 13 11.7281 13 11.5688V9.5Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClockRegular);
export default __webpack_public_path__ + "static/media/calendar-clock-regular.e2e1569e4107456b8988020a9588c155.svg";
export { ForwardRef as ReactComponent };